import { faCompress } from '@fortawesome/pro-light-svg-icons/faCompress';
import { faExpand } from '@fortawesome/pro-light-svg-icons/faExpand';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faSparkles } from '@fortawesome/pro-light-svg-icons/faSparkles';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { QBox, QButton, QIcon, QText, QStack } from '@captivateiq/quotient';

import { useAIShellContext } from '../AIShellContext';

export const HeaderAIShell = () => {
  const { t } = useTranslation('assistant');
  const { toggleShell, openNewChat, isExpanded, toggleExpanded } = useAIShellContext();

  return (
    <QStack
      direction="row"
      spacing={1.5}
      sx={{
        alignItems: 'center',
        backgroundColor: 'white',
        borderBottom: '1px solid',
        borderBottomColor: 'grey.300',
        color: 'grey.700',
        height: '60px',
        padding: '16px',
      }}
    >
      <QIcon icon={faSparkles} sx={{ fontSize: '16px' }} />
      <QText sx={{ fontSize: '16px', fontWeight: 600 }}>CaptivateAI</QText>
      <QBox sx={{ flexGrow: 1 }} />
      <QButton color="primary" variant="outlined" onClick={openNewChat} onMouseDown={(event) => event.preventDefault()}>
        <QIcon icon={faPlus} sx={{ marginRight: '8px' }} />
        <QText>{t('button_labels.new_chat')}</QText>
      </QButton>
      <QButton
        aria-label={isExpanded ? t('button_labels.collapse') ?? '' : t('button_labels.expand') ?? ''}
        sx={{
          minWidth: '24px',
          width: '24px',
          height: '24px',
          padding: '4px',
        }}
        variant="text"
        onClick={toggleExpanded}
      >
        <QIcon icon={isExpanded ? faCompress : faExpand} sx={{ fontSize: '16px' }} />
      </QButton>
      <QButton
        sx={{
          minWidth: '24px',
          width: '24px',
          height: '24px',
          padding: '4px',
        }}
        variant="text"
        onClick={toggleShell}
      >
        <QIcon icon={faXmark} sx={{ fontSize: '16px' }} />
      </QButton>
    </QStack>
  );
};
